import type { FaireProductEntity } from "../../entity_types/product";

export const p_k8h3pn2zz2: FaireProductEntity = {
  token: "p_k8h3pn2zz2",
  type: "product",
  name: "Bible Study Club Tote",
  brandToken: "b_3yqyd5scgp",
  brandName: "Way Maker Yeg",
  imageUrl:
    "https://cdn.faire.com/fastly/e72b1027edc65c59fa81374df15e91000745cd346c4e96b180a1954bc4c778e1.png",
  galleryImageUrls: [],
  priceDollars: 14.49,
  description:
    '\nIdeal for daily use, such as carrying large items, running errands \n\nlike grocery shopping etc.\n\n\n\nDESIGN : Bible Study Club \n\nDESCRIPTION :\n\n * 12 oz., 100% heavy cotton canvas \n * Large main compartment with zippered closure \n * Inside zippered flap pouch pocket \n * 25" self-fabric handles \n * 11" handle drop \n * Direct to Film Prints ',
  tags: [],
  msrpDollars: 23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:57.255Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
